import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useRegency(province_id?: string) {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const params: { [key: string]: number | string | undefined } = {};
  if (province_id) params.province_id = province_id;

  const refetch = (province_id?: string) => {
    setLoading(true)

    api.get("/regencies/", {
      params: { province_id: province_id }
    }).then((res: SuccessFetch<{
      payload: {
        province_id?: string
        regency_id: string
        regency_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.regency_name,
          value: item.regency_id,
          province_id: item.province_id
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    api.get("/regencies/", { params }).then((res: SuccessFetch<{
      payload: {
        province_id?: string
        regency_id: string
        regency_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.regency_name,
          value: item.regency_id,
          province_id: item.province_id
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}